import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import classNames from 'classnames';
import { Checkbox } from '@alifd/next';
import "./index.scss";
function CheckCell(props) {
  var className = props.className,
    invisible = props.invisible,
    indeterminate = props.indeterminate,
    checked = props.checked,
    onChange = props.onChange,
    _props$getProps = props.getProps,
    getProps = _props$getProps === void 0 ? function () {
      return {};
    } : _props$getProps;
  var inputProps = getProps();

  // Respect Next Checkbox inner state
  // https://gitlab.alibaba-inc.com/next/next/blob/master/src/checkbox/checkbox.jsx#L176
  if ('checked' in props) {
    inputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
      checked: checked
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-spm": props['data-spm'],
    className: classNames('list-check-cell', className),
    style: {
      visibility: invisible ? 'hidden' : undefined
    }
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    indeterminate: indeterminate
  }, inputProps, {
    onChange: onChange
  })));
}
export default CheckCell;